import { Component, OnInit, Input } from '@angular/core';
import * as QRCode from 'qrcode';

@Component({
    selector: 'app-qr-code-popup',
    templateUrl: './qr-code-popup.component.html',
    styleUrls: ['./qr-code-popup.component.scss']
})
export class QrCodePopupComponent implements OnInit {
    @Input() url: string = '';
    qrCodeImage: string = '';

    constructor() { }

    ngOnInit(): void {
        QRCode.toDataURL(this.url)
            .then(url => {
                this.qrCodeImage = url;
            })
            .catch(err => {
                console.error(err);
            });
    }
    close() {
        // You'll need to emit an event or call a method to inform the parent component to close the popup
    }

    onBackdropClick(event: MouseEvent) {
        this.close();
    }

    onPopupClick(event: MouseEvent) {
        // Prevents the click on the popup from closing it
        event.stopPropagation();
    }
}
